import { faBell } from "@fortawesome/free-regular-svg-icons";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Badge from "../../common/badge/Badge";
import Line from "../../common/line/Line";
import City from "./City";
import BurgerMenu from "./menu/BurgerMenu";
import Logo from "./menu/Logo";
import UserInfo from "./menu/UserInfo";
import {
  NavigationBar,
  NavigationDropdownMenuItem,
  NavigationEnd,
  NavigationLink,
  NavigationStart,
} from "./navigation";
import { InfoBarContext } from "../../common/info";
import { ThemeContext } from "../../common/theme/ThemeContext";
import NotificationPanel from "../../common/notifications/NotificationPanel";
import { isDesktop } from "../../utils/screenUtil";
import { GET } from "../../utils/fetchUtil";
import "../header/Header.scss";

function Header({ user }) {
  const location = useLocation();
  const { t } = useTranslation();
  const infoBar = useContext(InfoBarContext);
  const theme = useContext(ThemeContext);

  const [notificationsCount, setNotificationsCount] = useState(0);

  useEffect(() => {
    GET("/notifications/count", (response) => {
      setNotificationsCount(response.count);
    });
  }, [location]);

  const toggleNotifications = () => {
    infoBar.toggle(`${t("notifications.title")}`, () => <NotificationPanel />);
    setNotificationsCount(0);
  };

  const headerNavigation = {
    width: "100%",
    backgroundColor: "#e0dae4", // bulma: 'has-background-purple-light'
    padding: "0.5rem",
  };

  return (
    <>
      <header className="hero-head">
        <nav className={`navbar has-background-${theme.navColor}`}>
          <Logo img={theme.logo} link={user.applicationConfiguration.externalLinks.homeLink}>
            <BurgerMenu
              backgroundBulmaColor={theme.navLinkColor}
              textBulmaColor={theme.iconColor}
              hoverBulmaColor={theme.iconColor}
            />
          </Logo>
          <City link={user.applicationConfiguration.dashboardUri} name={user.place}>
            <Badge
              className="is-clickable is-pulled-right mt-2 hidden-desktop-scss"
              iconBulmaColor={theme.navText}
              value={notificationsCount}
              icon={faBell}
              onClick={toggleNotifications}
            />
          </City>
          {/* Mobile navigation */}
          <NavigationBar id={"navigation"} backgroundBulmaColor={theme.navColor}>
            <NavigationStart
              isHidden={location.pathname === user.applicationConfiguration.dashboardUri}
            >
              <NavigationDropdownMenuItem
                label={t("requests.title").toUpperCase()}
                displayDropdownMenu={
                  location.pathname !== user.applicationConfiguration.dashboardUri
                }
                isHorizontal={true}
                displayLabel={false}
                className={"is-hidden-desktop navi-exception"}
              >
                <NavigationLink
                  className={"navi-exception"}
                  exact={true}
                  to="/submitRequest"
                  label={t("requests.submit")}
                />
                <NavigationLink
                  className={"navi-exception"}
                  exact={false}
                  to="/requests"
                  label={t("requests.created")}
                />
                <NavigationLink
                  className={"navi-exception"}
                  exact={true}
                  to="/archive"
                  label={t("requests.archive")}
                />
                <NavigationLink
                  className={"navi-exception"}
                  exact={true}
                  to="/points"
                  label={t("requests.points")}
                />
                <NavigationLink
                  className={"navi-exception"}
                  exact={true}
                  to="/profile"
                  label={t("requests.myData")}
                />
                <NavigationLink
                  className={"navi-exception"}
                  exact={true}
                  to="/elections"
                  label={t("requests.voting")}
                />
              </NavigationDropdownMenuItem>
            </NavigationStart>
            <NavigationEnd>
              <UserInfo />
            </NavigationEnd>
          </NavigationBar>
        </nav>
        {/* Desktop navigation */}
        <div className="mb-2 hidden-mobile-scss navi-exception" style={headerNavigation}>
          <ul className="is-flex headerNavi navi-exception">
            <li>
              <NavigationLink
                exact={true}
                to="/submitRequest"
                label={t("requests.submit")}
                className={"is-size-4-touch is-size-4-desktop navi-exception"}
              />
            </li>
            <li>
              <NavigationLink
                exact={false}
                to="/requests"
                label={t("requests.created")}
                className={"is-size-4-touch is-size-4-desktop navi-exception"}
              />
            </li>
            <li>
              <NavigationLink
                exact={true}
                to="/archive"
                label={t("requests.archive")}
                className={"is-size-4-touch is-size-4-desktop navi-exception"}
              />
            </li>
            <li>
              <NavigationLink
                exact={true}
                to="/points"
                label={t("requests.points")}
                className={"is-size-4-touch is-size-4-desktop navi-exception"}
              />
            </li>
            <li>
              <NavigationLink
                exact={true}
                to="/profile"
                label={t("requests.myData")}
                className={"is-size-4-touch is-size-4-desktop navi-exception"}
              />
            </li>
            <li>
              <NavigationLink
                exact={true}
                to="/elections"
                label={t("requests.voting")}
                className={"is-size-4-touch is-size-4-desktop navi-exception"}
              />
            </li>
            <div className="container is-pulled-right has-text-right mr-4 mt-3 is-clickable hidden-mobile-scss">
              <Badge
                size={2}
                iconBulmaColor={theme.navLinkColor}
                value={notificationsCount}
                icon={faBell}
                iconSize={2}
                onClick={toggleNotifications}
              />
            </div>
          </ul>
        </div>
      </header>
    </>
  );
}

export default Header;
